import styled from 'styled-components';

/** The provider logo box of the mobile order list, a size smaller to suit
 *  the dialog's narrower cards. */
export const ProviderLogoBox = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 32px;
  padding: 0 4px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

/**
 * The modal footer's own background is a white fade, made for a lone button
 * row; the total above the buttons would sit in its see-through part, over
 * the cards scrolling underneath. This fills the footer edge to edge (the
 * negative margin undoes its 24px padding) with the modal's own colour and
 * draws a line where the scrolling list ends.
 */
export const SolidFooter = styled.div`
  margin: -24px;
  padding: 16px 24px 24px;
  background-color: ${({ theme }) => theme.background};
  border-top: 1px solid ${({ theme }) => theme.mediumGray};
  border-radius: 0 0 30px 30px;
`;
